import type { StorefrontEventContent, StorefrontEventName } from '@xshop/shared';

// What a storefront event tells a connected app's browser script.
export interface AppEventDetail {
  productId?: string;
  orderNumber?: string;
  value?: number;
  currency?: string;
  numItems?: number;
  contents?: StorefrontEventContent[];
  contentName?: string;
  eventId?: string; // the id the ad pixels fired the same step with, so an app can count it once
}

// One connected app's browser part: loading its script with the store's public ids, and the events it takes.
export interface BrowserApp {
  install: (settings: Record<string, string | boolean>, consented: boolean) => void;
  track: (name: StorefrontEventName, detail: AppEventDetail) => void;
}

// Adds a vendor's script to the page once, under an id that keeps a second call from loading it again.
export const injectScript = (id: string, src: string, attributes: Record<string, string> = {}): void => {
  if (document.getElementById(id)) return;
  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  for (const [name, value] of Object.entries(attributes)) script.setAttribute(name, value);
  document.head.appendChild(script);
};

// An app whose script only needs loading: chat widgets take no store events.
export const loadOnlyApp = (install: BrowserApp['install']): BrowserApp => ({ install, track: () => undefined });
